import React from 'react'

const useDebouncedEffect = (effect, deps, delay) => {
  React.useEffect(() => {
    const handler = setTimeout(() => effect(...deps), delay)
    return () => clearTimeout(handler)
  }, [...(deps || []), delay])
}

export default useDebouncedEffect
